import { createSlice } from "@reduxjs/toolkit";

export const promotionsSlice = createSlice({
  name: "promotions",
  initialState: { slider: [], socials: null },
  reducers: {
    getPromotionsSuccess: (state, action) => {
      return {
        ...state,
        slider: action.payload,
      };
    },
    getSocialsSuccess: (state, action) => {
      return {
        ...state,
        socials: action.payload,
      };
    },
    getWhatAppLinkSuccess: (state, action) => {
      return {
        ...state,
        whatsAppMagicLink: action.payload,
      };
    },
    getMobileSuccess: (state, action) => {
      return {
        ...state,
        isMobile: action.payload,
      };
    },
    getPromotionsError: (state) => state,
  },
});

export const {
  getPromotionsSuccess,
  getPromotionsError,
  getSocialsSuccess,
  getWhatAppLinkSuccess,
  getMobileSuccess,
} = promotionsSlice.actions;

export default promotionsSlice.reducer;
